export function calculateReadingTime(blocks: any[]) {
  if (!blocks) return { words: 0, minutes: 0 };
  
  let text = "";
  blocks.forEach((block) => {
    if (block._type === "block" && block.children) {
      block.children.forEach((child: any) => {
        if (child.text) {
          text += child.text + " ";
        }
      });
    }
  });

  const wordCount = text.trim().split(/\s+/).length;
  const readingTime = Math.ceil(wordCount / 200); // 200 words per minute average

  return {
    words: wordCount,
    minutes: readingTime
  };
}
export function formatTimeAgo(dateString: string) {
  if (!dateString) return "";
  
  const now = new Date();
  const published = new Date(dateString);
  const diffInSeconds = Math.floor((now.getTime() - published.getTime()) / 1000);

  if (diffInSeconds < 60) return "Just Now";
  
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours}h ${diffInMinutes % 60}m ago`;
  
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays === 1) return "Yesterday";
  if (diffInDays < 7) return `${diffInDays}d ago`;

  return published.toLocaleDateString();
}

export function slugify(text: string) {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');
}
